import { useCallback, useEffect } from 'react';
import { pick } from 'ramda';
import { debounce } from 'underscore';
import { useDeviceSelector } from 'js/store/hooks';

// todo not sure what is this really for, for now, left it for AdvancedPlayerMessage only
export const useResizeLayout = ({ layerRef, layoutRef }) => {
    const { os, browserName, isMobile } = useDeviceSelector(pick(['browserName', 'isMobile', 'os']));

    // ios chrome has problem with recalculate page size
    const isIosChrome = os === 'ios' && browserName === 'chrome';
    const updateLayoutSize = () => {
        const { width, height } = window.getComputedStyle(layerRef.current);
        const { minHeight } = window.getComputedStyle(layoutRef.current);
        const isPortrait = parseInt(height) / parseInt(width) >= 1;

        if (isMobile) {
            if (isPortrait) {
                layoutRef.current.style.minHeight = '';
            } else if (parseInt(minHeight) > parseInt(height)) {
                layoutRef.current.style.minHeight = 'var(--layout-max-height)';
            }
        }

        layoutRef.current.style.setProperty('--layout-width', width);
        layoutRef.current.style.setProperty('--layout-height', height);
    };

    const debouncedUpdateLayoutSize = debounce(updateLayoutSize, 300);
    // all deps are static, so...
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const resizeLayout = useCallback(isIosChrome ? debouncedUpdateLayoutSize : updateLayoutSize, []);

    useEffect(() => {
        resizeLayout();
        window.addEventListener('orientationchange', resizeLayout);
        window.addEventListener('resize', resizeLayout);

        return () => {
            window.removeEventListener('orientationchange', resizeLayout);
            window.removeEventListener('resize', resizeLayout);
        };
    }, [resizeLayout]);
};
